import GLightbox from 'glightbox';


const lightboxVideo = GLightbox({
  selector:  '.glightbox2',
  touchNavigation: true,
  autoplayVideos: true
});
